const CONFIG = {
  RESTAURANT_API_BASE_URL: 'https://restaurant-api.dicoding.dev',
  RESTAURANT_SMALL_IMAGE_URL: 'https://restaurant-api.dicoding.dev/images/small',
  RESTAURANT_MEDIUM_IMAGE_URL: 'https://restaurant-api.dicoding.dev/images/medium',
  RESTAURANT_LARGE_IMAGE_URL: 'https://restaurant-api.dicoding.dev/images/large',
  DATABASE_NAME: 'restaurant_database',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'favorite-restaurant',
};

export default CONFIG;
